<template>
  <div id="app">
    <!--header组件-->
    <v-header v-if="!isIE"></v-header>
    <!--视图-->
    <router-view className="view" v-if="!isIE"></router-view>
    <!--footer组件-->
    <v-footer className="bottom" v-if="!isIE"></v-footer>
    <low-version v-if="isIE">

    </low-version>
  </div>
</template>

<script>
import vHeader from './components/common/v-header';
import vFooter from './components/common/v-footer';
import LowVersion from './components/home/LowVersion.vue'

export default {
  components: {
    vHeader,
    vFooter,
    LowVersion
  },
  data() {
    return {
      isIE: false,
    }
  },
  created() {
    // this.setLang(localStorage.getItem('currentLangIndex') || '1' );
    this.IEVersion();
  },
  methods: {
    IEVersion() {
      //取得浏览器的userAgent字符串
      var userAgent = navigator.userAgent;
      //判断是否IE浏览器
      var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        // 小于ie10
        if (fIEVersion < 10 || !isSupportPlaceholder()) {
          this.isIE = true;
        }
      } else {
        this.isIE = false;
      }
    }

  }
}
</script>

<style lang="less">
#app {
  /*font-family:"Heiti SC","黑体-简";*/
  font-family: 'SimHei', '黑体' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  .view {
    max-width: 1920px;
    margin: 0 auto;
    min-height: calc(100vh - 240px);
    // min-height:100vh;
    margin-top: 8px;
    flex: 1;

    @media screen and(max-width: 1024px) {
      margin-top: 70px;
    }

    @media screen and(max-width: 769px) {
      margin-top: 50px;
    }
  }
}
</style>
